import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class PreventAuthAccessGuard {
  constructor(private router: Router, private localStorageService: LocalStorageService) {}

  canActivate(): boolean {
    const user = JSON.parse(this.localStorageService.getItem('user') || '{}');
    if (Object.keys(user).length > 0) {
      this.router.navigate(['/auditor']);
      return false;
    } else {
      return true;
    }
  }
}
